module.exports = __webpack_public_path__ + "static/media/iPhone15ProMax.db9c6635.png";